import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46811bc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Nos Livres ")
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("La Voix des Pierres et des Cristaux")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Les pierres et les cristaux sont des outils magnifiques et puissants qui nous aident, avec leur signature vibratoire, à agir sur notre système bioénergétique.")
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Lithothérapie Bioénergétique des Espaces ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("80 Pierres & cristaux pour vos lieux de vie et de travail")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" isentieridelvento.com ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Culture schiamaniche · evoluzione spirituale · benessere ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Nos Sites ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("larochemere.fr")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Le site de La Roche Mère")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("shungite.fr")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("La boutique en ligne")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("elixirs-mineraux.fr")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("La nouvelle gamme pour la méthode de lithothérapie bioénergétique.")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("rayonmagenta.fr")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Le site de Rayon Magenta")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("shungite-energiedevie.fr")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Le site du livre Shungite Energie de Vie")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("lithotherapie-bioenergetique.fr")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Le site de Regina Martino pour l'enseignement de la Lithothérapie et de la bioénergie.")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("bols-de-cristal.paris")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Site d'information sur les bols et les diapason de cristal")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "bg-black" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_scroll_area, { class: "absolute-full q-py-md" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, { class: "bg-grey-10 text-grey-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, {
                header: "",
                class: "bg-grey-9 text-grey-3 text-subtitle1"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, {
                clickable: "",
                tag: "a",
                target: "_blank",
                href: "https://shungite.fr/fr/livres-et-cartes/47-Livre-LA-VOIE-DES-PIERRES-ET-DES-CRISTAUX.html"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { avatar: "" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: require('../assets/voix-des-pierres.png'),
                        width: "55"
                      }, null, 8, _hoisted_2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { top: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_label, {
                        caption: "",
                        lines: "3",
                        class: "text-grey-5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { side: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "fas fa-chevron-right" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, {
                clickable: "",
                tag: "a",
                target: "_blank",
                href: "https://shungite.fr/fr/livres-et-cartes/47-Livre-LA-VOIE-DES-PIERRES-ET-DES-CRISTAUX.html"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { avatar: "" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: 
                require('../assets/lithotherapie-bioenergetique-des-espaces.jpg')
              ,
                        width: "55"
                      }, null, 8, _hoisted_5)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_label, {
                        caption: "",
                        class: "text-grey-5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { side: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "fas fa-chevron-right" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.locale === 'it')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_q_separator, { spaced: "" }),
                    _createVNode(_component_q_item_label, {
                      header: "",
                      class: "bg-grey-9 text-grey-3 text-subtitle1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('otherSites')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_item, {
                      clickable: "",
                      tag: "a",
                      target: "_blank",
                      href: "https://www.isentieridelvento.com"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_label, null, {
                              default: _withCtx(() => [
                                _hoisted_9,
                                _createVNode(_component_q_badge, {
                                  rounded: "",
                                  color: "teal",
                                  label: "it"
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_q_item_label, {
                              caption: "",
                              class: "text-grey-5"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_10
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_section, { side: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "fas fa-chevron-right" })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_q_separator, { spaced: "" }),
              _createVNode(_component_q_item_label, {
                header: "",
                class: "bg-grey-9 text-grey-3 text-subtitle1"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, {
                clickable: "",
                tag: "a",
                target: "_blank",
                href: "http://larochemere.fr/"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_label, {
                        caption: "",
                        class: "text-grey-5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { side: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "fas fa-chevron-right" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, {
                clickable: "",
                tag: "a",
                target: "_blank",
                href: "https://shungite.fr/"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_label, {
                        caption: "",
                        class: "text-grey-5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { side: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "fas fa-chevron-right" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, {
                clickable: "",
                tag: "a",
                target: "_blank",
                href: "https://elixirs-mineraux.fr/"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_label, {
                        caption: "",
                        class: "text-grey-5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { side: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "fas fa-chevron-right" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, {
                clickable: "",
                tag: "a",
                target: "_blank",
                href: "https://rayonmagenta.fr/"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _hoisted_18
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_label, {
                        caption: "",
                        class: "text-grey-5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { side: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "fas fa-chevron-right" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, {
                clickable: "",
                tag: "a",
                target: "_blank",
                href: "https://shungite-energiedevie.fr/"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_label, {
                        caption: "",
                        class: "text-grey-5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { side: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "fas fa-chevron-right" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, {
                clickable: "",
                tag: "a",
                target: "_blank",
                href: "https://lithotherapie-bioenergetique.fr/"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_label, {
                        caption: "",
                        class: "text-grey-5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { side: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "fas fa-chevron-right" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item, {
                clickable: "",
                tag: "a",
                target: "_blank",
                href: "https://bols-de-cristal.paris/"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _hoisted_24
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_label, {
                        caption: "",
                        class: "text-grey-5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_25
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { side: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "fas fa-chevron-right" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}